
export default  {
    language: "俄罗斯",
    // Навигация
    NEW:{
        title:"наиболее надежная платформа для сделок с цифровыми активами ",
        title2:"получение до 30% возврата наличных средств и 0045% операционных издержек ",
        l3:"Начало ",
        l4:"Основная область ",
        l5:"зона инноваций",
        l18:'DeFi (округ)',
        l6:'рынок ',
        l7:'валюта',
        l8:'окончательная цена сделки',
        l9:'суточная переменная',
        l10:'24 часа минимум ',
        l11:'24 часа максимум',
        l12:'круглосуточный объем ',
        l13:'покупать',
        l14:'Тенденции + ',
        l15:'открыть вашу сделку в OMGFIN ',
        l16:'вход',
        l18:'регистрация ',
        l19:'обувная площадка ',
        l20:'наиболее надежная платформа для сделок с цифровыми активами',
        l21:'о нас ',
        l22:'О ',
        l23:'Соглашение об обслуживании',
        l24:'конфиденциальное заявление',
        l25:'тарифный стандарт',
        l26:'подсказка риска',
        l27:'Проект AML',
        l28:'обслуживание клиентов',
        l29:'Документ API',
        l30:'заявка на получение денег',
        l31:'филиал',
        l32:'помочь',
        l33:'обслуживание клиентов',
        l34:'почтовый ящик: support@omgfin.com',
        l35:'Социальные средства массовой информации',
        l36:'главный получатель ',
        l37:'продать ',
        s1:'время поручения',
        s2:'общая сумма',
        s3:'цена',
        s4:'валюта',
        s5:'удостоверение личности пользователя',
        s6:'возвратит',
        s7:'валюта',
        s8:'время поручения',
        s9:'общая сумма ',
        s10:'цена',
        s11:'валюта',
        s12:'изменение в процентах',
        s13:'заключительная цена',
        s14:"финансовый счёт",
        s15:"ходатайствовать о размораживании",
        s16:"запись",
        s17:"вращение",
        s18:"Общий актив",
        s19:"монетный счёт",
        s20:"финансовый счёт",
        s21:"Введите целое число",
        s22:"замораживание",
        s23:"точно разморозить",
        s24:"определение",
        s25:"отмена",
        s26:"время размораживания",
        s27:"фиксировать",
        s28:"разморозить"
        
    },
    zdy: {
        ygsy: "Ориентировочный доход",
        jssj: "Конец времени",
        fhjg: "Цена вопроса",
        fhzl: "Всего выпущено",
        gw: "Официальный сайт",
        bps: "Белая книга",
        sgzq: "Срок подписки",
        xmxq: "Сведения о проекте",
        год: "Предварительный нагрев",
        sg: "Подписка",
        js: "Конец",
        rgcz: "Операция по подписке",
        srrgsl: "Введите количество подписок",
        rg: "Подписаться",
        kdh: "Заменяемый",
        yjs: "Завершено",
        wks: "не начато",
        jxz: "В процессе",
        ieorg: "Подписка IEO",
        scsj: "Время блокировки",
        qbye: "Баланс Кошелька",
        cslb: "Список заблокированных позиций",
        cs: "Заблокировать позицию",
        zqx: "Отменено",
        zwc: "Завершено",
        zyz: "В СИЗО",
        syl: "Доходность",
        ts: "Дни",
        cbgz: "Правила блокировки",
        zywa: "Залог майнинга",
        sftjmcj: "Подавать ли цену продажи заявки",
        sftjmrj: "Указывать ли закупочную цену заказа",
        пролосс: 'стоп-профит стоп-лосс',
        scwk: "Блокировка добычи на складе"
    },
     header: {
        home: 'Home',
        markets: "цитата",
        fiat: 'транзакция в фиатной валюте',
        c2c: 'Транзакция C2C',
        exchange: 'транзакция с монетой',
        lever: 'Контрактная сделка',
        micro: 'вторая контрактная сделка',
        myshop: "Мой магазин",
        assets: "Мои активы",
        help: "Справочный центр",
        login: "Логин",
        sign: "регистрация",
        accountSet: 'Настройки учетной записи',
        tradeLog: 'Торговый журнал',
        receiveSet: 'Настройки получения',
        identify: "Идентификация личности",
        jchange: 'обмен монет',
        logout:'выход',
        themedark: 'ночной режим',
        themeday: "Дневной режим",
    },
    // авторизуемся Зарегистрироваться
    lg: {
        login: "Войти",
        register: "регистрация",
    },
    // Домой
    home:{
        vol: '24-часовой объем',
        c01: "Ведущая в мире платформа для торговли цифровыми активами",
        c02: "Предоставлять безопасные и надежные услуги по торговле цифровыми активами и управлению активами для миллионов пользователей в более чем 130 странах по всему миру",
        c03: "безопасно и надежно",
        c04: "5 лет опыта в сфере финансовых услуг, связанных с цифровыми активами",
        c05: "Профессиональная распределенная архитектура и система защиты от DDOS атак",
        c06: "Глобальный экологический план",
        c07: "В нескольких странах созданы локализованные центры обслуживания транзакций",
        c08: "Создание экосистемы блокчейн с множеством бизнес-форм",
        c09: "сначала пользователь",
        c10: "Установить механизм предоплаты",
        c11: "Создать фонд защиты инвесторов",
        c12: 'в любое время и в любом месте мультиплатформенная терминальная транзакция',
        c13: "Покрытие iOS, Android, Windows для нескольких платформ, поддержка полных бизнес-функций",
        sweep:'Сканировать код для загрузки',
        android: 'Android',
        pinput: 'Пожалуйста, введите свой адрес электронной почты или номер телефона',
        atrade: "Зарегистрируйте глобальную учетную запись OMGFIN, чтобы начать торговое путешествие"
    },
    foo :{
        about: 'О нас',
        support:"Поддержка пользователей",
        contact:"Свяжитесь с нами",
        qq:'Служба поддержки клиентов QQ',
        email:'Контактный адрес электронной почты',
    },
    market: {
        handicap: "гандикап",
        exchange: 'валюта монеты',
        selfmarket: 'Дополнительно',
        allmarket: 'весь рынок',
        symbol: 'торговая пара',
        newprice: 'Последняя цена',
        change: "Рост",
        highprice: "Самая высокая цена",
        lowprice: 'самая низкая цена',
        vol: '24-часовой объем',
    },
    td: {
        buy:"купить",
        sell: "Продам",
        currency: "Валюта",
        num: 'число',
        time: "Время",
        limit: 'Limit',
        price: 'цена за единицу',
        method: 'Способ оплаты',
        total: "Итого",
        inwant: 'Пожалуйста, укажите свое желание',
        do: "Операция",
        more: "Загрузить еще",
        nomore: 'Больше нет',
        nodata: 'Временно нет данных',
        buynum: 'Купить количество',
        sellout: "продать",
        buyin: "Купить",
        all: "Все",
        allbuy: 'Купить все',
        allsell: "Продать все",
        buytotal: "Пожалуйста, введите общую сумму, которую вы хотите купить",
        selltotal: "Введите общую сумму, которую вы хотите продать",
        buyallnum: "Введите количество, которое вы хотите купить",
        sellallnum: "Пожалуйста, введите количество, которое вы хотите продать",
        tradeTotal: 'Общая сумма транзакции',
        doceil: 'Автоматически отменять через секунды',
        place: "Оформить заказ",
        waitpay: 'Ожидающий платеж',
        paycode: 'Код оплаты',
        finished: "завершено",
        ceiled: 'Отменено',
        payed: "заплатил",
        buyer: 'незавершенной',
        seller: "продавец",
        callWay: "Продавец",
        callWay: 'Контактная информация',
        placeTime: 'Время заказа',
        renum: 'ссылочный номер',
        canceil: 'Отмена',
        confirm: "Подтвердить",
        pwd: 'Пожалуйста, введите пароль транзакции',
        coincode: 'денежная единица',
        pcoin: "Пожалуйста, выберите валюту",
    },
    // транзакция в фиатной валюте
    fat:{
        // LegalPayDetail
        orderLog: 'Запись заказа',
        fatdLog: 'Записи транзакций в фиатной валюте',
        shoper: 'Торговец',
        faLog: 'Записи транзакций в фиатной валюте',
        tdType: 'Тип транзакции',
        odStatus: 'Статус заказа',
        pwaitPay: "Подождите, пока покупатель заплатит",
        odFinish: 'Заказ выполнен',
        odCeil: "Заказ был отменен",
        odPay: 'оплачено, внимательно проверьте информацию о платеже',
        tdCeil: 'Отменить транзакцию',
        pCeil: "Если вы уже заплатили продавцу, не отменяйте транзакцию",
        paySure: 'подтверждение платежа',
        pdopay: "Подтвердите, что вы заплатили продавцу",
        badClick: 'Злонамеренный щелчок приведет к прямому замораживанию учетной записи',
        receivePay: 'Подтверждение получения',
        payReceive: "Подтвердите, что покупатель заплатил вам",
        receivePays: 'Подтвердить получение платежа',
        // LegalPay
        payPlease: 'Пожалуйста, заплатите',
        tdPrice: 'Цена единицы транзакции',
        tdNum: 'Количество транзакций',
        payinfo: "Платежная информация",
        banknum: 'Банковский счет',
        realName: 'настоящее имя',
        shoperZname: 'Филиал продавца',
        shoperNum: 'Торговый счет',
        odCeil: 'Отменить заказ',
        imPay: "Я заплатил, нажмите для подтверждения",
        // LegalSeller
        register_time: 'Время регистрации',
        odtotal: 'Порядок сборки',
        odmonth: '30 дней, чтобы стать заказом',
        odfinish: 'закончить заказ',
        odrate: 'Коэффициент завершения',
        submit: 'релиз',
        phone:'Мобильный телефон',
        mysell: 'моя распродажа',
        mybuy: "Моя покупка",
        realAuth: 'Аутентификация реального имени',
        advAuth: 'Расширенная аутентификация',
        linebuy: 'Купить в Интернете',
        linesell: 'онлайн-продажа',
        tipPay: "Свяжитесь с продавцом в течение 24 часов, чтобы произвести платеж, он будет автоматически отменен через 24 часа",
        notlow: 'не может быть ниже минимального лимита',
        nothigh: "Максимальный предел не может быть превышен",
        notnum: 'Не может превышать максимальное число',
        // LegalShopDetail
        type: 'Type',
        status: "Статус",
        seeOrder: 'Посмотреть заказ',
        withdraw: "Вывод",
        abnormal: "ненормальный",
        lowershelf: 'с полки',
        protection: "защита прав",
        apply: 'Подать заявку на защиту прав',
        psType: 'Выберите тип',
        pselect: 'Пожалуйста, выберите',
        alipay: 'Alipay',
        Wechat: 'WeChat',
        bank: "Банковская карта",  
        minNum: 'Минимальный объем транзакции',
        maxNum: 'Максимальный объем транзакции',
        wantBuy: 'Купить',
        pnums: 'Пожалуйста, введите номер',
        pmin: 'Введите минимальный объем транзакции',
        pmax: 'Пожалуйста, введите максимальный объем транзакции',
        pnot: 'Максимальный объем транзакции не может быть меньше минимального объема транзакции',
        // MyLegalShops
        myshops: "Мой магазин",
        name: 'Name',
        fiatSub: 'Принадлежит к фиатной валюте',
        shoper_balance: 'Баланс продавца',
        enterShop: 'Войти в магазин',
        // shop_legal_pay_detail
        payedWait: 'оплачено, ожидает подтверждения после проверки',
        yes: "Да",
        no: "нет",
        sd: 'заблокировать баланс',
        journal:"Журнал баланса",
        business: "Бизнес",
        user: 'User',
        backdone: 'Снято',
        busbalance: 'Деловой баланс',
        userbalance: 'Баланс пользователя',
    },
    ctc: {
        ctc: 'C2C',
        myRelease: 'C2C я выпустил',
        myTrade: 'C2C Я торговал',
        and:"Верный",
        balance: "Баланс",
        buynum: 'Объем покупок',
        sellnum: 'объем продаж',
        bankTransfer: "Банковский перевод",
        payim: "должен заплатить лично",
        pbuyNum: 'Введите количество покупок',
        pprice: 'Пожалуйста, введите цену за единицу',
        payway: "Выберите способ оплаты",
        psellNum: 'Пожалуйста, введите проданное количество',
        suerePlace: 'Вы уверены, что разместите заказ?',
        detail: "Детали",
        payinfo: "Платежная информация",
        Payee: "Получатель",
        total: "Итого",
        name: 'Name',
        cardnum: 'номер карты',
        receivePay: 'Подтвердить получение платежа',
        ceilConfirm: "Подтвердить отмену транзакции? ",
        paySeller: 'Подтвердите, что вы заплатили продавцу, и злонамеренные клики заблокируют ваш аккаунт',
        payBuyer: "Подтвердите, что вы получили платежную информацию покупателя",
        account: "Счет",
        sellerPay: "Подтвердите, что покупатель заплатил вам? ",
        payattion: "Пожалуйста, заплатите продавцу как можно скорее после подтверждения платежа, злонамеренные клики приведут к прямому замораживанию аккаунта",
        log: 'c2c выполнил заказ',
    },
    // контракт
    lever:{
        nowentrust: 'текущее доверие',
        hisentrust: 'историческая комиссия',
        lvchi: 'Контрактное держание',
        all: "Все",
        or:"или",
        gotrade: 'Начать торговать',
        tdrecord: 'Запись транзакции',
        dealed: 'Dealed',
        notdeal: 'Undealed',
        Loading: 'Загрузка ...',
        entotal: 'Всего введено в эксплуатацию',
        canuse: 'доступен',
        std: 'сделка по рыночной цене',
        xtd: 'Лимитная торговля',
        pprice: 'Пожалуйста, введите цену',
        phand: 'Введите количество купленных лотов',
        phandsell: 'Пожалуйста, введите количество проданных лотов',
        pwd: 'пароль',
        ppwd: 'Пожалуйста, введите пароль транзакции',
        psw: 'пароль транзакции',
        равно: 'равно',
        equal: "раз",
        times: "мультипликатор",
        timed: "рука",
        hand: "Руки",
        ptimes: 'Пожалуйста, выберите несколько',
        phands: 'Пожалуйста, выберите количество рук',
        contractVal: 'Рыночная стоимость контракта',
        bail: "Маржа",
        canBail: 'Доступная маржа',
        charge: "Комиссия за транзакционные услуги",
        domore: 'Купить (долго)',
        doshort: 'Продать (коротко)',
        dmore: 'делать больше',
        dshort: 'короткие',
        sureOd:'Подтвердить заказ',
        noless: "Количество рук не может быть меньше чем",
        nomore: 'Количество рук не может быть больше',
        tdnum: 'объем транзакции',
        risk: 'уровень риска',
        allloss: 'общая прибыль и убыток позиций',
        onehouse:"Ликвидация в он клик",
        type: 'Type',
        entrustPrice: 'Entrust Price',
        openPrice: 'Цена открытия',
        nowPrice: 'Текущая цена',
        styPrice: "Цена фиксации прибыли",
        stsPrice: 'Цена стоп-лосса',
        openTime: 'Время открытия',
        closeTime: 'Время закрытия',
        rate: 'плата за обработку',
        nightFee: 'Ночная плата',
        loss: 'Прибыль и убыток',
        setloss: 'Установить прибыль и стоп-лосс',
        expectProfit: 'Ожидаемая прибыль',
        expectLoss: 'Ожидаемый убыток',
        allClose: 'Закрыть все позиции',
        moreClose: 'Только закрывать больше заказов',
        nullClose: 'Закрывать только пустые заказы',
        sureClose: "Подтвердить закрытие позиции? ",
        thanZearo: 'Установленное значение должно быть больше 0',
        listin: 'Отложенный заказ',
        tdin: 'в транзакции',
        closein: 'Закрытая позиция',
        closed: 'Закрытая позиция',
        revoked: "отозвана",
        revokeOrder: "Вы действительно хотите отменить заказ? ",
        ping: 'Закрыть позицию',
        revoke: 'Отменить заказ',
        sureping: "Вы уверены, что закроете позицию? ",
        thanzone: 'Установленное значение должно быть больше 0'
       
    },
    // монеты
    Cuy: {
        direction: "Направление",
        total: "Итого",
        price: "цена",
        sell: "Продам",
        buy:"купить",
        allStation: 'Торговля на всех станциях',
        buyPrice: 'Цена покупки',
        buynum: 'Объем покупок',
        sellPrice: 'Цена продажи',
        sellnum: 'объем продаж',
        tdPrice: 'Сумма транзакции',
        or:"или",
        tdStart: 'Начать торговлю',
        pbPrice: 'Пожалуйста, введите покупную цену',
        pbNum: 'Введите сумму покупки',
        psPrice: "Пожалуйста, введите продажную цену",
        psNum: 'Пожалуйста, введите проданную сумму',
        fixPrice: 'Торговля по лимитной цене',
        Mtrans: 'сделка по рыночной цене',
        available: "Доступный",
        revoke: "Отозвать",
        loading: "Загрузка",
        confirmCancel: "Вы уверены, что хотите отменить? ",
        confirm: 'OK',
        cancel: "Отмена",
        nomore: 'Больше нет данных',
        evelPrice: 'Средняя цена сделки',
    },
    // активы
    asset:{
confirmhuazhuan: "Вы хотите подтвердить перевод?",
        assets: "активы",
        currency_account: 'валютный счет',
        lever_account: 'Контрактный счет',
        fince_account: 'счет в фиатной валюте',
        change_account: 'Торговый счет',
        micro_account: 'второй контрактный счет',
        miscroAccount: 'второй контрактный счет',
        assets_hua: 'перевод средств',
        all_assets: 'Всего преобразовано активов',
        currency: "валюта",
        canuse: 'доступен',
        frezz: 'заморозить',
        conversion: "Зарядка монет",
        charging: "Выход",
        address_bind: 'привязать адрес вывода',
        address_withdraw: 'Управление адресом вывода',
        
        record: "Запись",
        address_charge: 'Адрес монеты',
        address_width: 'Адрес для вывода',
        copy: "копия",
        ercode: 'QR-код',
        reminder: "Теплое напоминание",
        notcharge:"Не заряжайте ничего по указанному выше адресу",
        ornone: "В противном случае активы не будут возвращены",
        support: "Депозит поддерживает только простой метод отправки. Депозит с использованием других методов (отправить все) временно не может быть отправлен, пожалуйста, поймите. ",
        minnum: 'Минимальная сумма вывода',
        ratenum: 'плата за обработку',
        havenum: 'Количество прибытия',
        from:"Из" ,
        to: "до",
        transfer: "передача",
        tfnum: 'Количество передач',
        ptfnum: 'Пожалуйста, введите самый низкий',
        dtfnum: 'Количество переводов',
        canbalance: 'Доступный баланс',
        sureConfirm: 'Подтвердить перевод',
        moneyRecord: 'Финансовая запись',
        pNum: 'Пожалуйста, введите количество переводов',
        leverrUse: 'Контрактный счет доступен',
        legalUse: 'Доступен счет в законной валюте',
changeUselg: 'Доступны счета для монет',
        changeUse: 'Торговый счет доступен',
        microUse: 'Доступен второй контрактный аккаунт',
        look: 'View',
        chargeRecord: 'запись заряда монеты',
        status: 'Статус отслеживания',
        noopen: 'Эта функция еще не открыта',
        enterAdderses: 'Пожалуйста, введите адрес вывода',
        enterNum: 'Пожалуйста, введите количество монет',
        lessMin: 'Количество введенных выводов меньше минимального значения',
        tips01: "Не пополняйте счет другими активами на указанный выше адрес, иначе активы не будут восстановлены. ",
        tips02: "Депозит поддерживает только простой метод отправки, а депозит с использованием других методов (отправить все) временно не может быть отправлен. Пожалуйста, поймите. ",
        beizhu: 'Замечания',
        pbeizhu: 'Пожалуйста, введите примечание',
         add: "Добавить",
        addressList: 'Список адресов',
        delete: "Удалить",
        norec: 'Пока записей нет',
        selectCurrency: 'Выберите валюту',
        chainType: "тип цепи"
    },
    // настройки учетной записи
    set:{
        mycode2: 'Мой код авторизации',
        copycode2: 'Скопировать код авторизации',
        uaccont: 'Уровень безопасности вашего аккаунта:',
        strong: "сильный",
        middle: 'в',
        weak: "слабый",
        min: "низкий",
        Heigh: 'высокий',
        complete: "Дополнительные сведения для обеспечения безопасности учетной записи",
        mycode: 'Мой код приглашения',
        copycode: 'скопировать код приглашения',
        bindphone: "Привязать телефон",
        bindemail: 'привязать почтовый ящик',
        loginpwd: 'пароль для входа',
        noBind: 'Освобожденный',
        binds: "связывать",
        bind: 'Перейти к привязке',
        binded: "Ограниченность",
        net: 'Учетные записи Интернета могут быть украдены. Рекомендуется регулярно менять пароль для защиты своей учетной записи. ',
        reset: "изменить",
        setPsw: "Установить пароль транзакции для обеспечения безопасности транзакции. ",
        goSet: 'Перейти к настройке',
        bindAccount: 'привязать учетную запись погашения',
        duihuan: "привязать аккаунт к обмену баллов",
        copysuccess: 'Копирование выполнено успешно',
        copyfail: 'Ошибка копирования',
        recopy: 'скопируйте еще раз',
        account: "Счет",
        detail: "Детали",
        val: "количество",
        forgotPsw: 'забыл пароль',
        code: 'Проверочный код',
        getCode: 'Получить проверочный код',
        setPsw: 'Установить пароль',
        enterPsw: 'Пожалуйста, введите пароль',
        pswFalse: 'Два введенных пароля не совпадают',
        enterPswagain: 'Пожалуйста, введите пароль еще раз',
        jsetPsw: 'Установить пароль транзакции',
        jenterPsw: 'Пожалуйста, введите пароль транзакции',
        jenterPswagain: 'Пожалуйста, введите пароль транзакции еще раз',
        enterAccount: 'Пожалуйста, войдите в аккаунт',
        enterCode: 'Пожалуйста, введите проверочный код',
        accountFalse: 'Указанный вами телефон или адрес электронной почты не соответствует правилам!',
        second: "второй",
        sendCode: 'Отправить проверочный код',
        senducc: 'Отправить успешно',
        enterPswTwo: 'Пожалуйста, введите пароль дважды',
        rest: "Оставаясь",
        yes: "Да",
         no:" нет",
        yorn: 'Следует ли устанавливать пароль транзакции',
    },
    // Аутентификация
    Auth: {
        identity: 'аутентификация личности',
        name: 'Name',
        idcard: 'ID Card',
        upimg: 'Пожалуйста, загрузите фотографию на удостоверение личности, первая - это лицевая сторона, вторая - обратная сторона, а третья - фотография лицевой стороны фотографии на удостоверение личности. ',
        submit: "Отправить",
        auditing: 'Аудит ...',
        certified: '! Certified',
        pname: 'Пожалуйста, введите ваше имя',
        pidcard: 'Пожалуйста, введите идентификационный номер',
        pimg: 'Пожалуйста, загрузите фотографию своего удостоверения личности!',
    },
    // Способ оплаты
    SETING: {
        pmethod: 'способ оплаты',
        truename: 'настоящее имя',
        opening: "Название банка, открывающего счет",
        bank: 'Номер банковской карты',
        alipay: 'Учетная запись Alipay',
        wename: 'Псевдоним в WeChat',
        wechat: 'Учетная запись WeChat',
        pname: 'Пожалуйста, введите свое настоящее имя',
        popen: 'Пожалуйста, введите название банка счета',
        pcard: 'Пожалуйста, введите номер банковской карты',
        palipay: 'Пожалуйста, введите свой аккаунт Alipay',
        pwname: 'Пожалуйста, введите никнейм WeChat',
        pwaccount: 'Пожалуйста, войдите в учетную запись WeChat',
        pimg1: 'Код коллекции WeChat',
        pimg2: "Код платежа Alipay",
    },
    // Центр помощи
    news:{
        seeall: 'Просмотреть все',
        helpcenter: "Справочный центр",
        back: "Возвращение",


    },
    //авторизоваться
    login:{
        welcome: 'Добро пожаловать в систему',
        phoneLogin: 'Мобильный вход',
        emailLogin: 'Вход в почтовый ящик',
        account: "Счет",
        PSW: 'пароль',
        login: "Войти",
        nouser: "Еще не пользователь OMGFIN? ",
        goRegister: "Зарегистрируйтесь сейчас и начните торговать на ведущей мировой платформе для торговли цифровыми активами. ",
        registerFree: 'Бесплатная регистрация',
        psw6: 'Пароль не может быть меньше шести цифр',
    },
    register:{
        register: "регистрация",
        phoneRegister: "Телефонный реестр",
        emailRegister: 'Регистрация по электронной почте',
        country:"национальность страны'",
        enterPhone: 'Пожалуйста, введите свой номер телефона',
        enterEmail: 'Пожалуйста, введите свой адрес электронной почты',
        psw16: 'Пароль состоит из 6-16 цифр',
        inviteCode: 'код приглашения',
        sel: "Обязательно",
        sel2: 'не требуется',
        read: "Прочитал и согласен",
        xieyi: '"Пользовательское соглашение"',
        tips01: "Информация о гражданстве не может быть изменена после регистрации, пожалуйста, убедитесь, что вы выбрали правдиво. ",
        tips02: "Письмо с подтверждением может быть ошибочно признано спамом, пожалуйста, проверьте его внимательно. ",
        tips03: "Пожалуйста, сохраните свою учетную запись OMGFIN и пароль для входа в надлежащее состояние. ",
        tips04: "Не используйте тот же пароль для входа, что и на других сайтах. ",
        emailFalse:" Введенный вами адрес электронной почты не соответствует правилам"
    },
    // Выкупать
    х: {
        title: "Платформа JC Exchange Digital Assets BEAU",
        balance :"Баланс",
        cannum: 'Доступный номер JC',
        new: "Последняя цена",
        exnum: 'Обменное количество',
        pnum: 'Пожалуйста, введите номер JC',
        canex: 'Количество конвертируемых автомобилей BEAU',
        exnow: 'Обменять сейчас',
        record: 'Обменная запись',
        exprice: 'Обменная цена',
        extime: "Время обмена",
        not: 'Недостаточно доступных баллов',
        usenum: 'Использовать номер JC',
        out: "Выход",
        gotd: 'Перейти к делу',

    },
    coin:{
        manage: 'финансовый менеджмент',
        total: 'Всего монет депозита',
        bao: 'Положи сокровище',
        mybao: 'Моя депозитная монета',
        profit: "Ориентировочная прибыль",
        cuntime: 'Время монет',
        endtine: 'Срок действия',
    },
    team: {
        myteam: 'Моя команда',
        ztnum: 'Номер прямого нажатия',
        activenum: 'Количество активных членов команды',
        profit: "Прибыль",
        back: 'Rebate',
        cblog: 'запись о депозите монеты',
        bblog: 'запись монеты',
        
    },
     // k линия
     kline: {
        text1: 'Таймшер',
        text2: '1 минута',
        text3: '5 минут',
        text4: '15 минут ',
        text5: '30 минут',
        text6: '1 час',
        text7: '1 день',
        text8: '1 неделя',
        text9: 'Январь',
    },
    // второй контракт
    miscro: {
        trade: "Торговля",
        buyPrice: 'Закупочная цена',
        finshPrice: 'Цена транзакции',
        loss: 'Ожидаемые прибыли и убытки',
        times: "Обратный отсчет",
        mode: 'Режим торговли',
        num: 'количество открытых позиций',
        rate: 'норма прибыли',
        up: "Скупить",
        down: "Купить вниз",
        openNum: 'Введите количество открытий',
        success: "Заказ успешно размещен! ",
        c2c: "Учетная запись C2C",
        жалоба: "Предложение жалобы",
        complaint: "Запишите, пожалуйста, ваш вопрос, мы ответим вам как можно скорее ...",
        ComplaintList: "Список предложений жалоб",
        complaintReply: "Ответить:",
        complaintDescription: "Введите описание",
        resetpwd: "Сменить пароль",
        createdOn: "Создано",
        commonProblem: "Общая проблема",
        statement: "Объяснение",
        about: 'О OMGFIN',
        everyone: "Каждый - генеральный директор",
        program: "Глобальная партнерская программа OMGFIN",
        program2: "Партнерская программа",
        myMine: "Моя шахта:",
        friend: "Мой мой друг:",
        myRank: "Мой рейтинг:",
        accumulated: "Накопленная комиссия:",
        copyLinks: "Копировать рекламные ссылки",
        moneyVein: "Связи людей становятся деньгами",
        example: "Пример комиссии",
        enterQuantity: "Пожалуйста, введите количество",
        contractBalance: "Остаток на счете контракта",
        submitRepeatedly: "Отправка, пожалуйста, не отправляйте повторно",
        alipayCode: "Код платежа Alipay",
        wechatCode: "Код платежа Wechat",
        realPrice: "Цена в реальном времени",
        currencyExchange: "Обменять валюту",
        currencyExchangeIn: "Обменять на валюту",
        cashableBalance: "Обналичиваемый баланс:",
        minimumCashable: "Минимальная обналичиваемость:",
        maximumCashable: "Максимальное обналичивание:",
        automaticallys: "После нажатия на выкуп будет завершен автоматически и не может быть возвращен",
        match: "циферблат",
        title: "Обмен активами",
        holdAssets: "Держать активы",
        dangerousCurrency: "Опасная валюта",
        convertibleQuantity: "Конвертируемое количество",
        currencyExchanges: "Курс обмена валюты:",
        insuranceCurrency: "Страховая валюта",
        insuranceType: "Тип страхования",
        contractAsset: "Сумма страхования активов по контракту",
        warehouses: "Количество безопасных складов",
        availableAssets: "Доступные активы:",
        insuredAssets: "Застрахованные активы:",
        insuredAssets1: "Застрахованные активы",
        insuranceAssets: "Страховые активы:",
        PurchaInsurance: "Страхование покупок",
        insuranceClaims: "Страховые претензии",
        insuranceCancellation:"Отмена страховки",
        coinWallet: "Кошелек с застрахованными монетами",
        bmbWallet: "Кошелек HAP",
        cumulativeCoins: "Суммарные монеты:",
        availableQuantity: "Доступное количество:",
        rawCurrency: "Кредитная запись",
        contractInsurance: "Страхование договора",
        tenThousand: "Ten thousand",
        runningLow: "Недостаточный баланс",
        purchase: "Введенное вами количество не соответствует правилам, и ваша сумма покупки находится в",
        reach: "до",
        between: "между",
        onlyEnter: "Вы можете только войти",
        inteersBetween: "Между целыми числами",
        notReturned: "Нажмите, чтобы приобрести страховку, считается, что вы подробно поняли договор страхования и согласились с тем, что страховой склад автоматически вступит в силу и не может быть возвращен",
        notReturned: "Когда застрахованный актив проигрывает до такой степени, что заказ не может быть размещен, страхование урегулирует претензию",
        settled: "времена, когда актив прибыльный",
        profitable: "Когда страхование прекращается автоматически",
        terminated: "Когда застрахованный актив теряет 50%, вы должны подать заявление на страхование, в противном случае вы не можете торговать. Когда прибыль составляет 100%, страхование автоматически прекращается. Страховому складу разрешается платить только два раза в день. Если более двух раз, платит t + 1",
        automatically: "После прекращения страхования застрахованные активы можно только обменять. После расторжения договора это будет считаться дефолтом, и страховой склад будет автоматически очищен.",
        termination: "положительно",
        назад: "анти -",
        lowNumber: "Наименьшее число",
        confirmExchange: "Подтвердить обмен?",
        contractValuation: "Оценка активов контрактного счета",
        secondValuation: "Оценка активов второго контрактного счета",
        falshValuation: "Оценка активов Fashion Account",
        c2cValuation: "Оценка активов аккаунта C2C",
        recordWithdrawal: "Запись о пополнении и снятии средств",
        category: 'Категория',
        safetyCenter: "Центр безопасности",
         safeText1: "Используется для получения проверочного SMS при регистрации, изменении паролей и настроек безопасности",
         safeText2: "Учетные записи Интернета могут быть украдены. Рекомендуется регулярно менять пароль для защиты своей учетной записи.",
         flashTrading: "Флэш-трейдинг",
         assetCenter: "Центр активов",
         promotionCode: "Мой промокод",
         loginAgain: "Имя пользователя устарело, пожалуйста, войдите снова",
         text10: "Цена в реальном времени на основе HAP",
         text11: "Код авторизации",
     }

    
}


// WEBPACK FOOTER //
// ./src/lang/ru.js